import { post } from 'api/api';
import { CreateAffiliateClickPayload } from './types/affiliateClick';

export async function trackAffiliateClick(values: CreateAffiliateClickPayload) {
  return post('/services/affiliateclick/', values);
}
